import type { Block, IngredientType } from 'components/IngredientsAndEquipment';

export const parseIngredients = (block: Block) => {
  const ingredientsAndEquipmentBlocks = block && block?.IngredientsAndEquipmentBlocks;

  if (!ingredientsAndEquipmentBlocks) return [];

  return ingredientsAndEquipmentBlocks.map((ingredient) => ({
    title: ingredient?.Title ?? '',
    ingredients:
      ingredient?.Ingredients?.map((items) => ({
        summary: items.ArticleSummaryText,
        amount: items.AmountAndUnitSummaryText,
        productLink: items.ArticleUnit?.Article?.ProductLink || null,
      })) ?? [],
  }));
};

export interface IngredientPrint {
  summary?: string;
  amount?: string;
  productLink?: string;
  printHeight?: number;
  title?: string;
  list?: string[];
}

export const parseIngredientsPrint = (block: Block, lineHigh: number, space: number) => {
  const ingredientsAndEquipmentBlocks = block && block?.IngredientsAndEquipmentBlocks;

  if (!ingredientsAndEquipmentBlocks) return [];
  return ingredientsAndEquipmentBlocks.reduce<IngredientPrint[]>((acc, ingredient) => {
    const newAcc: IngredientPrint[] = [...acc];

    if (ingredient.Title) {
      newAcc.push({
        title: ingredient.Title,
        printHeight: space + lineHigh,
      });
    }

    if (ingredient.Ingredients) {
      const ingredients = ingredient.Ingredients.map((items) => ({
        summary: items.ArticleSummaryText,
        amount: items.AmountAndUnitSummaryText,
        productLink: items.ArticleUnit?.Article?.ProductLink,
        printHeight: lineHigh,
      }));

      return [...newAcc, ...ingredients];
    }

    return newAcc;
  }, []);
};

export const parseEquipments = (block: Block) => {
  const ingredientsAndEquipmentBlocks = block && block?.IngredientsAndEquipmentBlocks;

  if (!ingredientsAndEquipmentBlocks) return [];

  return ingredientsAndEquipmentBlocks
    .filter((item) => item.VisibleEquipmentItemPositions.length)
    .map((equip) => ({
      title: equip.Title,
      list: equip.VisibleEquipmentItemPositions.map((item) => item.EquipmentItem.Title),
    }));
};

export const parseProducts = (block: Block) => {
  const productList = block.IngredientsAndEquipmentBlocks.flatMap((ingredient) =>
    ingredient?.Ingredients?.filter((item) => item.ArticleUnit?.Article?.ProductLink),
  );
  return productList;
};

export const filterUniqueProducts = (products: IngredientType[]): IngredientType[] => {
  return products.filter((product, index, self) => {
    return (
      index ===
      self.findIndex(
        (p) =>
          p.ArticleSummaryText === product.ArticleSummaryText &&
          p.ArticleUnit?.Article?.ProductLink === product.ArticleUnit?.Article?.ProductLink,
      )
    );
  });
};
